var map = {
	"./1.png": 1199,
	"./2.png": 4151,
	"./3.png": 3110,
	"./3D Prniters.png": 965,
	"./4.png": 9051,
	"./5.png": 2375,
	"./6.png": 6250,
	"./7.png": 7695,
	"./8.png": 9307,
	"./AndalusiaHospitals.png": 4476,
	"./HafezRoyal.png": 754,
	"./Interactive Boards.png": 7155,
	"./Light Current.png": 9246,
	"./Networking.png": 2482,
	"./Networks.png": 8898,
	"./PCs & Laptops.png": 530,
	"./Printers.png": 3220,
	"./Servers.png": 7249,
	"./Smart Factory.png": 6124,
	"./SmartHomeDevices.png": 7975,
	"./Suez.png": 7950,
	"./UPS.png": 3396,
	"./buy one.png": 7983,
	"./cisco.png": 9557,
	"./customer-service.png": 2017,
	"./dell.png": 5299,
	"./empty-saved-items.png": 2309,
	"./fontawesome/css/all.css": 3462,
	"./fontawesome/css/all.min.css": 101,
	"./fontawesome/css/brands.css": 7575,
	"./fontawesome/css/brands.min.css": 3718,
	"./fontawesome/css/fontawesome.css": 1730,
	"./fontawesome/css/fontawesome.min.css": 472,
	"./fontawesome/css/regular.css": 2545,
	"./fontawesome/css/regular.min.css": 7877,
	"./fontawesome/css/solid.css": 9806,
	"./fontawesome/css/solid.min.css": 9688,
	"./fontawesome/css/svg-with-js.css": 1888,
	"./fontawesome/css/svg-with-js.min.css": 5300,
	"./fontawesome/css/v4-font-face.css": 9616,
	"./fontawesome/css/v4-font-face.min.css": 47,
	"./fontawesome/css/v4-shims.css": 5604,
	"./fontawesome/css/v4-shims.min.css": 4568,
	"./fontawesome/css/v5-font-face.css": 9757,
	"./fontawesome/css/v5-font-face.min.css": 9007,
	"./fontawesome/webfonts/fa-brands-400.ttf": 9626,
	"./fontawesome/webfonts/fa-brands-400.woff2": 2626,
	"./fontawesome/webfonts/fa-regular-400.ttf": 5417,
	"./fontawesome/webfonts/fa-regular-400.woff2": 1814,
	"./fontawesome/webfonts/fa-solid-900.ttf": 3744,
	"./fontawesome/webfonts/fa-solid-900.woff2": 9844,
	"./fontawesome/webfonts/fa-v4compatibility.ttf": 6458,
	"./fontawesome/webfonts/fa-v4compatibility.woff2": 5036,
	"./footer-bg.png": 1243,
	"./goals.png": 7450,
	"./hero-section-footer.png": 6375,
	"./hp.png": 6221,
	"./image_1.png": 1265,
	"./infra.png": 5926,
	"./infrastructure.png": 986,
	"./integered-img.png": 9088,
	"./khalilPharmacy.png": 9178,
	"./left_corner.png": 3444,
	"./lenovo.png": 6546,
	"./logo.png": 6949,
	"./main-1-1.png": 5102,
	"./main-1.png": 1234,
	"./main-2.png": 1921,
	"./microsoft.png": 9933,
	"./mission.png": 5044,
	"./net.png": 3615,
	"./no-product-found.png": 2215,
	"./queue.png": 5177,
	"./queueSystem.png": 1619,
	"./right_corner.png": 3721,
	"./sales-team.png": 9083,
	"./samsung.png": 3833,
	"./smart11.png": 2479,
	"./smartHomes.png": 903,
	"./softw.png": 7891,
	"./software.png": 8257,
	"./veeam.png": 6874,
	"./vision.png": 3711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;